<template>
  <el-form
    :model="formGroup"
    :rules="ruleformGroup"
    ref="formGroup"
    label-width="100px"
  >
    <el-form-item label="组ID" prop="groupId">
      <el-input
        v-model.trim="formGroup.groupId"
        :maxlength="32"
        :disabled="!edit"
        placeholder="请输入组ID"
      ></el-input>
    </el-form-item>
    <el-form-item label="组名称" prop="name">
      <el-input
        v-model.trim="formGroup.name"
        :maxlength="32"
        :disabled="!edit"
        placeholder="请输入组名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="组管理员" prop="groupAdmin">
      <el-input
        v-model.trim="formGroup.groupAdmin"
        :maxlength="32"
        :disabled="!edit"
        placeholder="请输入组管理员"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
    props: {
        formGroup: {
            type: Object,
            default: () => {}
        },
        edit: {
          type: Boolean,
          default: true
        }
    },
    data(){
        return {
            ruleformGroup: {
                groupId: [{ required: true, message: "请输入组ID", trigger: "blur" }],
                name: [{ required: true, message: "请输入组名称", trigger: "blur" }]
            }
        }
    },
    methods: {
      resetForm(){
        this.$refs["formGroup"].resetFields()
      },
      validateForm() {
        let validate = false
        this.$refs['formGroup'].validate((valid) => {
          if (valid) {
            validate = true
          }
        });
        return validate
      },
    }
}
</script>
<style>
.el-textarea__inner{
  padding: 5px 10px;
}
</style>